"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _reactHooks = require("@trycourier/react-hooks");

var _react = _interopRequireWildcard(require("react"));

var _BusinessFooter = require("./BusinessFooter");

var _FreeFooter = require("./FreeFooter");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Footer = function Footer(_ref) {
  var _preferences$preferen;

  var draft = _ref.draft;
  var preferences = (0, _reactHooks.usePreferences)();
  (0, _react.useEffect)(function () {
    preferences.fetchPreferencePage(draft);
  }, []);

  if (preferences.isLoading || !preferences.preferencePage) {
    return null;
  }

  var FooterWrapepr = _styledComponents["default"].div.withConfig({
    displayName: "Footer__FooterWrapepr",
    componentId: "kj82c3-0"
  })(["width:100%;margin-top:16px;> div{height:80px;padding:10px;}"]);

  return /*#__PURE__*/_react["default"].createElement(FooterWrapepr, null, (_preferences$preferen = preferences.preferencePage) !== null && _preferences$preferen !== void 0 && _preferences$preferen.showCourierFooter ? /*#__PURE__*/_react["default"].createElement(_FreeFooter.FreeFooter, null) : /*#__PURE__*/_react["default"].createElement(_BusinessFooter.BusinessFooter, {
    links: preferences.preferencePage.brand.links,
    theme: preferences.preferencePage.brand.settings.colors.primary
  }));
};

exports.Footer = Footer;